/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.chip {
  border-radius: var(--radius-sm, 0.25rem);
  display: flex;
  justify-content: space-between;
  gap: calc(var(--spacing, 0.25rem) * 2);
  padding: calc(var(--spacing, 0.25rem) * 2);
  width: fit-content;
  align-items: center;
}
.border {
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: var(--color-primary-500);
}
.chip.small {
  min-height: calc(var(--spacing, 0.25rem) * 8);
  padding-block: var(--spacing, 0.25rem);
}
.chip.default {
  background-color: var(--color-primary-100);
  color: var(--color-primary-500);
}
.chip.include {
  background-color: var(--color-success-light, #dcfce7);
  color: var(--color-success-dark, #15803d);
}
.chip.exclude {
  background-color: var(--color-danger-light, #fef2f2);
  color: var(--color-danger-dark, #b91c1c);
}
.content {
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
}
.content.withButton {
  padding-left: calc(var(--spacing, 0.25rem) * 2);
}
.button {
  --tw-border-style: none;
  border-style: none;
  width: calc(var(--spacing, 0.25rem) * 6);
  height: calc(var(--spacing, 0.25rem) * 6);
}
.button.default {
  color: var(--color-primary-500);
}
.button.default:hover {
  color: var(--color-primary-700);
}
.button.include {
  color: var(--color-success-dark, #15803d);
}
.button.exclude {
  color: var(--color-danger-dark, #b91c1c);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}
